<template>
    <div ref="messagePane" :style="paneStyles">
        <div style="padding: 1rem 2rem 5rem 1rem">
            <div v-for="(items, date) in chronology">

                <!-- Date Marker !-->
                <conversation-date-marker
                    :date="date"
                ></conversation-date-marker>

                <div v-for="(item, index) in items" :key="index">

                    <!-- Message !-->
                    <message
                        :ref="'message[' + item.id + ']'"
                        v-if="isMessage(item)"
                        :message="item"
                        :show-message-actions="shouldShowMessageActions(conversation, item)"
                        @reply="reply"
                    />

                    <!-- Note !-->
                    <conversation-note
                        v-if="isNote(item)"
                        :note="item"
                    ></conversation-note>

                    <!-- Action !-->
                    <conversation-action
                        v-else-if="isAction(item)"
                        :action="item"
                    ></conversation-action>

                </div>

            </div>

            <!-- Reply Editor !-->
            <conversation-reply-editor
                ref="reply"
                v-if="replying"
                @sent="replySent"
                @reset="resetReply"
            />

            <!-- Note Editor !-->
            <conversation-note-editor
                ref="note"
                v-if="addingNote"
                @saved="noteSaved"
                @reset="resetNote"
            />
        </div>
    </div>
</template>

<script>
    import Message from './ConversationMessage'
    import ConversationReplyEditor from "./ConversationReplyEditor";
    import ConversationNoteEditor from "./ConversationNoteEditor";
    import ConversationAction from "./ConversationAction";
    import ConversationNote from "./ConversationNote";
    import ConversationDateMarker from "./ConversationDateMarker";

    export default {
        components: {
            ConversationDateMarker,
            ConversationAction,
            ConversationNote,
            ConversationNoteEditor,
            ConversationReplyEditor,
            Message
        },
        mounted() {
            this.setInitialScroll()

            window.Echo.private(`conversation.${this.conversation.id}`)
                .listen('.message.event', (e) => {
                    if (['sent', 'delivered', 'seen', 'clicked', 'permanent_fail'].includes(e.event.type)) {
                        this.$store.commit('inbox/conversations/incrementMessageEventCount', {
                            id: e.event.message.id,
                            type: e.event.type,
                        })
                    }
                });
        },
        props: {
            negativeYMargin: {
                type: String,
                default: '0px'
            }
        },
        data() {
            return {
                replying: false,
                addingNote: false,
            }
        },
        computed: {
            conversation() {
                return this.$store.getters['inbox/conversations/conversation'];
            },
            chronology() {
                if (this.conversation && this.conversation.id) {
                    return this.conversation.chronology
                }

                return []
            },
            paneStyles() {
                return { maxHeight: 'calc(100vh - ' + this.negativeYMargin + ')',  overflowY: 'auto' }
            }
        },
        methods: {
            isAction(chronologyItem) {
                return chronologyItem.chronology_item_type === 'action'
            },
            isNote(chronologyItem) {
                return chronologyItem.chronology_item_type === 'note'
            },
            isMessage(chronologyItem) {
                return chronologyItem.chronology_item_type === 'message' &&
                    (chronologyItem.medium === 'email' || chronologyItem.medium === 'text')
            },
            isLatestMessage(conversation, message) {
                return conversation.latest_message &&
                    conversation.latest_message.id === message.id
            },
            shouldShowMessageActions(conversation, message) {
                return !this.isOutbound(message) &&
                    this.isLatestMessage(conversation, message)
                    && !this.replying
            },
            resetReply() {
                this.replying = false
            },
            reply() {
                this.resetNote()

                this.replying = true

                this.setInitialScroll()
            },
            replySent() {
                this.replying = false

                this.$store.dispatch('inbox/conversations/reload').then(() => {
                    this.setInitialScroll()
                })
            },
            addNote() {
                this.resetReply()

                this.addingNote = true

                this.setInitialScroll()
            },
            noteSaved() {
                this.resetNote()

                this.$store.dispatch('inbox/conversations/reload').then(() => {
                    this.setInitialScroll()
                })
            },
            resetNote() {
                this.addingNote = false
            },
            isOutbound(message) {
                return !!message.to.primary_display_as
            },
            setInitialScroll() {
                setTimeout(() => {
                    this.scrollToBottom()
                }, 300)

                this.scrollToBottom()
            },
            scrollToBottom() {
                this.$nextTick(() => {
                    if (!this.$refs.messagePane) {
                        return
                    }

                    this.$refs.messagePane.scrollTo({ top: this.$refs.messagePane.scrollHeight, behavior: 'smooth'})
                })
            },
            focus(message_id) {
                this.$refs['message[' + message_id + ']'][0].$el.scrollIntoView({behavior: 'smooth'})
            }
        }
    }
</script>